export default __webpack_public_path__ + "static/media/doctores_formato.ddbdae0c.xlsx";